<style scoped>
*{
  padding: 0;
  margin: 0;
  list-style: none;
  margin-bottom: 10px;
}
a{
  text-decoration: none;
}
.zhu-swiper{
  width: 100%;
  /* height: 300px; */
  height: auto; /* 高度自动调整,便于自动缩放，不能写死 */
}
.swiper-slide img{
  width: 100%;
  /* height: 100%; */
  height: 58vh; /* 改成视口一半高度 */
  object-fit: cover; /* 防止图片变形，可选 */
}
/* 控制左右俩个图片缩小 */
.swiper-slide-prev img {
            transform: scale(1); /* 左右图片缩小 */
        }
.swiper-slide-next img {
            transform: scale(1); /* 左右图片缩小 */
        }
.swiper-slide-active img {
            transform: scale(1); /* 当前图片正常大小 */
        }
.swiper .red-icon {
  display: block;
  object-fit: cover;
  width: 300px;   /* 设置你想要的大小 */
  height: 400px;
  object-fit: contain; /* 保证比例不变 */
}
.slide-wrapper {
  position: relative;  /* 作为定位参照 */
}
/* Red 图片覆盖在每张图上方 */
.red-icon {
  position: absolute;
  bottom: -120px;
  left: 20%;
  transform-origin: center center; /* 缩放以自身中心点为基准 */
  transition: transform 0.3s ease; /* 平滑过渡 */
  
  width: 100px;
  height: auto;
  z-index: 2; /* 保证在主图上层 */
}


/* 悬停时放大，不移动 */
.red-icon:hover {
  transform: scale(1.2); /* 放大，不再受 translateX 影响 */
  
}
/* 只让 02MKQYBg 往上偏 */
.up-focus {
  object-position: center 0%;  /* 👈 往上移 */
}
</style>
<template>  
  <div class="swiper zhu-swiper">  
    <swiper :options="swiperOptions"> 
      
        <swiper-slide v-for="(slide, index) in slides" :key="index">  
          <div class="slide-wrapper"><!--  作为Red图片的定位参照  Red 图片始终覆盖在其他图片上方-->
          <!-- 如果是 MainPageBG14.png，就带路由跳转 -->
          <router-link v-if="slide.image === 'MainPageBG14.png'" to="/oneGameViewVue">
            <img :src="require(`@/assets/img/${slide.image}`)" :alt="slide.alt" >  
          </router-link>
          <!-- 其他图片正常显示 -->
          <img v-else :src="require(`@/assets/img/${slide.image}`)" :alt="slide.alt" :class="{ 'up-focus': slide.image === '02MKQYBg.png' }">  <!--只让 02MKQYBg 往上偏  -->

          <!-- Red 图片跳转 -->
          <!-- <router-link v-if="slide.image === 'MainPageBG14.png'" to="/oneGameViewVue">
            <img src="@/assets/img/Red.png" alt="red" class="red-icon">
          </router-link> -->
          <!-- Red 图片始终覆盖在上方 -->
          <!-- <img v-else src="@/assets/img/Red.png" alt="red" class="red-icon"> --><!-- 不使用else 1.第一个包在 <router-link> 里（有跳转） 2.第二个始终显示（没跳转）导致第二个 <img> 覆盖在上面，挡住了 <router-link> 的可点击区域，所以点击 Red 图片时永远不会跳-->
          <router-link :to="slide.link">
            <img src="@/assets/img/Red.png" alt="red" class="red-icon">
          </router-link>

          </div>
        </swiper-slide>  
         
      <!-- 如果需要分页器 -->  
      <div class="swiper-pagination" slot="pagination"></div>  
  
      <!-- 如果需要导航按钮 -->  
      <div class="swiper-button-next" slot="button-next"></div>  
      <div class="swiper-button-prev" slot="button-prev"></div>  
  
      <!-- 更多自定义选项，如滚动条、效果等 -->  
    </swiper>  
  </div>  
</template> 

<script>  
export default {  
  data() {  
    return {  
      swiperOptions: {  
        slidesPerView: 1,  
        spaceBetween: 30,  
        loop: true,
        autoplay:true,  //自动切换
        navigation: {  
          nextEl: '.swiper-button-next',  
          prevEl: '.swiper-button-prev',  
        },  
        pagination: {  
          el: '.swiper-pagination',  
          clickable: true,  
        },  

        // 更多配置项...  
      },  
      slides: [  
        /* { image: '20250213204801.png', alt: 'Image 1' },  
        { image: '20250213204818.png', alt: 'Image 2' },  
        { image: '20250213204834.png', alt: 'Image 3' },  
        { image: '20250213204842.png', alt: 'Image 4' },  */
        { image: 'MainPageBG14.png', alt: 'Image 1',link: '/oneGameViewVue' },  
        { image: '02MKQYBg.png', alt: 'Image 2' ,link: '/mkqy02GameVue'},  
        // ...更多slide数据  
      ],  
    };  
  },  
  // ...  
};  
</script>  
